<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XecZWK/tc-custom/Cover.jpg?1684274655934?1702529787934" alt="This image is the cover for the book Haunted Prince William County, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Prince William County, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p>With a nearly three-hundred-year history, Prince William County has its share of haunted tales and scary spots. Ghosts still haunt the battlefield at Manassas, including the Ben Lomond Plantation, site of a Civil War-era hospital. The jailhouse in Brentsville keeps many of its captives in ghostly form. The Weems Botts House, home of George Washington's biographer, Parson Weems, is still haunted by the spirit of one of its owners. Local author and historian Andrew Mills narrates the best and creepiest tales of hauntings throughout the county.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew L. Mills
      </h2>
      
      <p class="authorDescription body article">Born and raised in Prince William County, historian Andrew Mills has worked as a tour guide with Alexandria Colonial Tours and helps interpret George Washington's Mount Vernon, reenacts at Rippon Lodge and provides historical insight for visitors coming to the Northern Virginia area. He has been featured on Destination America and C-Span, and his program Virginia Time Travel has been airing episodes since 2006. He is the author of Alexandria 1861-1865 (coauthored with Charles A. Mills), The Washington Heir, The Female Stranger and The Stolen Sash.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a4fe15a